import { Form, Input } from "decorator-form";
import React from "react";

import InputType from "common/form/InputType";
import EmbedView from "common/views/embed/Embed.view";
import { ITab, TabsView } from "common/views/tab/Tabs.view";
import TypographyView from "common/views/typographyView/Typography.view";
import Label from "core/components/label/Label";
import {
	ArticleTypeRegistry,
	IArticleType,
	IArticleTypeComponentProps
} from "../IArticleType";
import ArticleGlossaryTermList from "../ArticleGlossaryTermList";

@Form()
class EmbedArticle {
	@Input({
		type: InputType.TEXT,
		title: "Embed URL",
		description: "(https)"
	})
	public url: string;

	public tabs?: Array<{ key: string; label: string; content: string }>;
}

function EmbedArticleComponent({
	article,
	attachmentDisplay,
	contributorDisplay,
	uiSchema
}: IArticleTypeComponentProps<EmbedArticle>) {
	const tabs: ITab[] = [];

	tabs.push({
		key: "content",
		label: <Label k="article.content" v="Content" />,
		content: <EmbedView viewKey="embed" src={uiSchema.url} />
	});

	if (article.contributors && article.contributors.length) {
		tabs.push({
			key: "contributors",
			label: <Label k="article.contributors" v="Contributors" />,
			content: contributorDisplay
		});
	}

	if (attachmentDisplay) {
		tabs.push({
			key: "attachments",
			label: <Label k="article.attachments" v="Attachments" />,
			content: attachmentDisplay
		});
	}

	const url = new URL(window.location.href);
	const knowledgeBaseId = url.searchParams.get("knowledgeBaseId");
	const articleId = url.searchParams.get("articleId");

	tabs.push({
		key: "glossary",
		label: <Label k="article.glossary" v="Glossary" />,
		content: (
			<ArticleGlossaryTermList
				knowledgeBaseId={knowledgeBaseId}
				articleId={articleId}
			/>
		)
	});

	if (uiSchema.tabs) {
		uiSchema.tabs.forEach(t =>
			tabs.push({
				key: t.key,
				label: <Label k={"tab." + t.key} v={t.label} />,
				content: (
					<TypographyView viewKey="tab.content" html={t.content} />
				)
			})
		);
	}

	return <TabsView viewKey="tabs" tabs={tabs} />;
}

const EmbedArticleType: IArticleType<EmbedArticle> = {
	type: "article:embed",
	label: "Embed",
	icon: "globe",
	component: EmbedArticleComponent,
	configClass: EmbedArticle
};

export default ArticleTypeRegistry.putObject(EmbedArticleType);



// WEBPACK FOOTER //
// ./src/panels/kb/article/articleType/EmbedArticle.reg.tsx